import { DELETE_CANCELLATION } from '../../constants/actions/policy';

export function deleteCancellation(payload) {
    return {
        type: DELETE_CANCELLATION,
        payload,
    };
}
